import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ShoppingBagIcon from '@ingka/ssr-icon/paths/shopping-bag';
import ShoppingBagActiveIcon from '@ingka/ssr-icon/paths/shopping-bag-active';
import styled from 'styled-components';
import { SkapaButton } from '@inter-ikea-guida/skapa';
import IkeaLogo from '../assets/ikea-logo.svg';
import { useGuidaPromptContext } from '../context/promptContext';
/* Styles are replicated from the kompis implementation */
const StyledHeaderWrapper = styled.div `
  display: block;

  @media (min-width: ${props => props.$theme.breakpoint.xxlarge.width / 16}rem) {
    display: flex;
    justify-content: center;
  }
`;
const StyledHeader = styled.header `
  position: fixed;
  top: 0;
  z-index: 2;
  background: white;
  display: flex;
  width: 100%;
  height: ${80 / 16}rem;
  padding-left: ${props => props.$theme.spacing.space150 / 16}rem;
  padding-right: ${props => props.$theme.spacing.space150 / 16}rem;

  @media (min-width: ${props => props.$theme.breakpoint.medium.width / 16}rem) {
    padding-left: ${props => props.$theme.spacing.space200 / 16}rem;
    padding-right: ${props => props.$theme.spacing.space200 / 16}rem;
  }

  @media (min-width: ${props => props.$theme.breakpoint.large.width / 16}rem) {
    height: ${90 / 16}rem;
    padding-left: ${props => props.$theme.spacing.space250 / 16}rem;
    padding-right: ${props => props.$theme.spacing.space250 / 16}rem;
  }

  @media (min-width: ${props => props.$theme.breakpoint.xlarge.width / 16}rem) {
    display: grid;
    grid-template-columns: repeat(13, minmax(0, 1fr));
    column-gap: ${props => props.$theme.spacing.space125 / 16}rem;
    padding-left: ${props => props.$direction === 'rtl'
    ? props.$theme.spacing.space300 / 16
    : props.$theme.spacing.space125 / 16}rem;
    padding-right: ${props => props.$direction === 'rtl'
    ? props.$theme.spacing.space125 / 16
    : props.$theme.spacing.space300 / 16}rem;
  }

  /** Centralize the component with auto margins. */
  @media (min-width: ${props => props.$theme.breakpoint.xxlarge.width / 16}rem) {
    margin-left: auto;
    margin-right: auto;
    max-width: ${1792 / 16}rem; /* 122rem, matches the max width of Ikea main page layout*/
  }
`;
const StyledLeftMenu = styled.div `
  display: block;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${props => props.$theme.breakpoint.xlarge.width / 16}rem) {
    display: flex;
  }

  @media (max-width: ${props => props.$theme.breakpoint.xlarge.width / 16}rem) {
    display: none;
  }
`;
const StyledRightMenu = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: ${props => props.$theme.breakpoint.xlarge.width / 16}rem) {
    grid-column: 2 / span 12;
  }
`;
const StyledRightMenuButtons = styled.div `
  display: flex;
  align-items: center;
  gap: ${props => props.$theme.spacing.space50 / 16}rem;
  margin-right: -${10 / 16}rem;
`;
const StyledLogoLink = styled.a `
  display: flex;
  align-items: center;
`;
const StyledStaticLogo = styled.div `
  display: flex;
  align-items: center;
`;
const StyledLogo = styled.img `
  width: ${90 / 16}rem;
  height: ${36 / 16}rem;
`;
const StyledLogoAndGuidaSlot = styled.div `
  display: flex;
  align-items: center;
  gap: ${props => props.$theme.spacing.space150 / 16}rem;
`;
export const GuidaMainHeader = ({ theme, settings, kompisTranslations, activeShoppingBag, isRtl, guidaSlot, disableLinks, showShoppingBag, cartUrl = settings.kompis.urls.shoppingCartLink, children }) => {
    const { openPrompt } = useGuidaPromptContext();
    const direction = isRtl ? 'rtl' : 'ltr';
    const isMobile = window.matchMedia(`(max-width: ${theme.breakpoint.xlarge.width}px)`).matches;
    const shouldDisplayShoppingBag = showShoppingBag && !disableLinks;
    return (_jsx(StyledHeaderWrapper, { "$theme": theme, children: _jsxs(StyledHeader, { "$theme": theme, "$direction": direction, "data-testid": 'main-header', children: [_jsx(StyledLeftMenu, { "$theme": theme, children: !isMobile && children }), _jsxs(StyledRightMenu, { "$theme": theme, children: [_jsxs(StyledLogoAndGuidaSlot, { "$theme": theme, children: [!disableLinks ? (_jsx(StyledLogoLink, { "data-testid": 'ikea-logo-link', href: settings.kompis.urls.homePageLink, onClick: e => {
                                        e.preventDefault();
                                        openPrompt();
                                    }, children: _jsx(StyledLogo, { src: IkeaLogo, alt: 'IKEA' }) })) : (_jsx(StyledStaticLogo, { children: _jsx(StyledLogo, { src: IkeaLogo, alt: 'IKEA' }) })), guidaSlot] }), _jsxs(StyledRightMenuButtons, { "$theme": theme, children: [shouldDisplayShoppingBag && (_jsx(SkapaButton, { size: 'small', type: 'primary', inverseTheme: true, text: kompisTranslations.shoppingBagLinkTo, iconOnly: true, ssrIcon: activeShoppingBag ? ShoppingBagActiveIcon : ShoppingBagIcon, onClick: () => {
                                        window.open(cartUrl, '_blank');
                                    } })), isMobile && children] })] })] }) }));
};
//# sourceMappingURL=GuidaMainHeader.js.map